import { render, staticRenderFns } from "./ManageModal.vue?vue&type=template&id=24a1cb8b&lang=pug"
import script from "./ManageModal.vue?vue&type=script&lang=js"
export * from "./ManageModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Icon: require('/home/docker/code/frontend/components/Icon.vue').default})
